document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-fam-nav-toggle]');
  var nav = document.querySelector('[data-fam-main-nav]');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', function () {
    var isOpen = nav.classList.toggle('fam-open');
    toggle.classList.toggle('fam-open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  document.addEventListener('click', function (e) {
    if (!nav.classList.contains('fam-open')) return;
    if (nav.contains(e.target) || toggle.contains(e.target)) return;
    nav.classList.remove('fam-open');
    toggle.classList.remove('fam-open');
    toggle.setAttribute('aria-expanded', 'false');
  });

  var navItems = document.querySelectorAll('[data-fam-nav-item]');
  navItems.forEach(function (item) {
    var mainLink = item.querySelector('[data-fam-nav-link]');
    if (!mainLink) return;
    mainLink.addEventListener('click', function (e) {
      var isMobile = window.matchMedia('(max-width: 1200px)').matches;
      if (!isMobile) return;
      if (!item.classList.contains('fam-open')) {
        e.preventDefault();
        navItems.forEach(function (other) { other.classList.remove('fam-open'); });
        item.classList.add('fam-open');
      }
    });
  });

  document.addEventListener('click', function (e) {
    navItems.forEach(function (item) {
      if (item.contains(e.target)) return;
      item.classList.remove('fam-open');
    });
  });
});
